import SALESFORCE_EMPTY from '@/assets/images/salesforce-empty.svg?raw';

import { Box, Heading, Paragraph } from '@customerio/pluma-components/react';
import * as salesforceCardStyles from './salesforce-request-access-card.css';

export function SalesforceInfoCard() {
  return (
    <Box textAlign="center" className={salesforceCardStyles.salesforceInfoCard}>
      <Box
        mb="150"
        dangerouslySetInnerHTML={{
          __html: SALESFORCE_EMPTY,
        }}
      />
      <Heading level="3" color="active" weight="medium" mb="150">
        Effortlessly send your Salesforce data to all of your tools—no engineering or manual work required.
      </Heading>
      <Paragraph color="subtle" mb="150">
        From contacts to accounts to opportunities, Data Pipelines makes it simple to send all your Salesforce data to
        Journeys and external destinations. Get started on your own in minutes.
      </Paragraph>
    </Box>
  );
}
